
// Generated file by php first URL
export default {
  allColors:{
    paraPrivilege:{
      mainColor:'#00a796',
      secondaryColor: '#00cdb8'
    },

    universPharmacie:{
      mainColor:'#003264',
      secondaryColor: '#ffcc00'
    },

    pharmaCarte:{
      mainColor:'#fe3e9e',
      secondaryColor: '#fe3e9e'
    }
  }
}



// WEBPACK FOOTER //
// ./src/styles/Colors.js